import React, { useMemo } from 'react';
import { Filter, FilterFrame, FilterSelection, GroupWrapper } from '../Filters.style';
import { FilterOption } from '../../../types';
import CheckboxSelector from '../../CheckboxComponent';
import { ExposedFiltersTypes, FilterTypes } from '../../../constants/initialFilters';
import FilterExposedHeader from '../FilterExposedHeader';
import useAnimations from '../../../hooks/Animations/useAnimations';

interface GearboxSelectorTypes {
  filterType: string;
  filterOptions: {
    [key: string]: FilterOption;
  };
  temporaryFilters: FilterTypes;
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string) => void;
  handleExposeFilter: (arg: string) => void;
}

const GearboxSelector: React.FC<GearboxSelectorTypes> = ({
  filterType,
  filterOptions,
  temporaryFilters,
  handleAddFilter,
  handleExposeFilter,
  openedFiltersList,
}) => {
  const selectedGearboxList = useMemo(() => {
    const seletedTrimlineOptions = temporaryFilters.gearBox;
    return seletedTrimlineOptions.map((gearBox) => filterOptions[gearBox].label).join(', ');
  }, [temporaryFilters.gearBox, filterOptions]);

  const selectedGearbox = useMemo(() => {
    return temporaryFilters.gearBox;
  }, [temporaryFilters.gearBox]);

  const showFilter = openedFiltersList[filterType];

  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(showFilter);

  return (
    <Filter>
      <FilterExposedHeader
        filterType={filterType}
        selectedFilterLabels={selectedGearboxList}
        handleExposeFilter={handleExposeFilter}
        openedFiltersList={openedFiltersList}
      />
      {dropdownAnimation(
        (props, item) =>
          item && (
            <FilterSelection style={props} data-testid="gearbox-filter-group">
              <FilterFrame style={filtersAccordianAnimation}>
                <GroupWrapper>
                  {Object.keys(filterOptions).map((filterOption, index) => {
                    const option = filterOptions[filterOption];
                    return (
                      <CheckboxSelector
                        label={option?.label}
                        ariaLabel={(option.label as string) || ''}
                        key={option?.value}
                        value={option?.value}
                        onChange={(value) => handleAddFilter(filterType, value)}
                        inputName={`${option?.value}-${index}`}
                        checked={selectedGearbox.includes(option.value)}
                      />
                    );
                  })}
                </GroupWrapper>
              </FilterFrame>
            </FilterSelection>
          ),
      )}
    </Filter>
  );
};

export default GearboxSelector;
